import {
  GetCustomResourceFieldsDocument,
  GetCustomResourceFieldsQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useCustomResourceFields = (variables: GetCustomResourceFieldsQueryVariables) => {
  const { data, loading } = useQuery(GetCustomResourceFieldsDocument, {
    variables,
  })

  return {
    loading,
    customResourceFields: data?.customFields.resourceFieldsConnection.nodes,
  }
}
